import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  companyDetails: null,
  billingAddresses: null,
  pickupAddresses: null,
  fetchingCountries: false,
  fetchingStates: false,
  fetchingCities: false,
  addingAddress: false,
  updatingAddress: false,
  countries: [],
  states: [],
  cities: [],
};

const viewCompanySlice = createSlice({
  name: "viewCompany",
  initialState,
  reducers: {
    fetchCompanyDetails(state, action) {
      state.loading = true;
    },
    fetchCompanyDetailsSuccess(state, action) {
      state.companyDetails = action.payload.data.document;
      state.loading = false;
    },
    fetchCompanyDetailsFailure(state, action) {
      state.loading = false;
    },
    fetchCompanyPickupAddress(state, action) {
      state.loading = true;
    },
    fetchCompanyPickupAddressSuccess(state, action) {
      state.pickupAddresses = action.payload.data.document;
      state.loading = false;
    },
    fetchCompanyPickupAddressFailure(state, action) {
      state.loading = false;
    },
    fetchCompanyBillingAddress(state, action) {
      state.loading = true;
    },
    fetchCompanyBillingAddressSuccess(state, action) {
      state.billingAddresses = action.payload.data.document;
      state.loading = false;
    },
    fetchCompanyBillingAddressFailure(state, action) {
      state.loading = false;
    },
    fetchCountries(state, action) {
      state.fetchingCountries = true;
    },
    fetchCountriesSuccess(state, action) {
      state.fetchingCountries = false;
      state.countries = action.payload.data.document;
    },
    fetchCountriesFailure(state, action) {
      state.fetchingCountries = false;
    },
    fetchStates(state, action) {
      state.fetchingStates = true;
    },
    fetchStatesSuccess(state, action) {
      state.fetchingStates = false;
      state.states = action.payload.data.document;
    },
    fetchStatesFailure(state, action) {
      state.fetchingStates = false;
    },
    fetchCities(state, action) {
      state.fetchingCities = true;
    },
    fetchCitiesSuccess(state, action) {
      state.fetchingCities = false;
      state.cities = action.payload.data.document;
    },
    fetchCitiesFailure(state, action) {
      state.fetchingCities = false;
    },
    /*   addAddress(state, action) {
      state.addingAddress = true;
    },
    addAddressSuccess(state, action) {
      state.addingAddress = false;
    },
    addAddressFailure(state, action) {
      state.addingAddress = false;
    },
    updateAddress(state, action) {
      state.updatingAddress = true;
    },
    updateAddressSuccess(state, action) {
      state.updatingAddress = false;
    },
    updateAddressFailure(state, action) {
      state.updatingAddress = false;
    }, */
  },
});

export const { actions, reducer, name: sliceKey } = viewCompanySlice;
